import React, { useMemo } from "react";
import { formatCurrency } from "../../utils/helpers";

/** Distinct palette (bars + legend) */
const PROVIDER_COLORS = [
  "#3b6ea8",
  "#b8791e",
  "#6b6a66",
  "#1f6b34",
  "#7c3aed",
  "#c0262b",
  "#0284c7",
  "#db2777",
];

const Report20ProviderDonutChart = ({ data = [] }) => {
  const raw = data || [];
  const chartData = useMemo(
    () =>
      raw.map((item, index) => ({
        ...item,
        color: PROVIDER_COLORS[index % PROVIDER_COLORS.length],
      })),
    [raw]
  );

  const maxVal = useMemo(
    () => chartData.reduce((m, r) => Math.max(m, parseFloat(r.totalMRC) || 0), 0) || 1,
    [chartData]
  );

  if (!chartData.length) {
    return (
      <p className="px-5 py-8 text-center text-[13px] text-[var(--muted,#6b6a66)]">
        No provider data
      </p>
    );
  }

  return (
    <>
      <div className="px-5 pt-4 pb-3">
        <h3 className="text-[16px] font-semibold text-[var(--ink,#1c1c1a)]">
          Spend by provider
        </h3>
        <p className="mt-0.5 text-[12px] text-[var(--muted,#6b6a66)]">
          Share of total MRC
        </p>
      </div>
      <ul className="px-5 pb-4 space-y-3">
        {chartData.map((entry, index) => {
          const amount = parseFloat(entry.totalMRC) || 0;
          const pct = Math.min(100, Math.round((amount / maxVal) * 100));
          return (
            <li key={entry.provider + index} className="flex items-center gap-3">
              <div className="w-[7.5rem] shrink-0 flex items-center gap-2 min-w-0">
                <span
                  className="h-2.5 w-2.5 shrink-0 rounded-[3px]"
                  style={{ backgroundColor: entry.color }}
                />
                <span className="truncate text-[13px] font-medium text-[var(--ink,#1c1c1a)]">
                  {entry.provider}
                </span>
              </div>
              <div className="flex-1 min-w-[80px] h-2.5 rounded-full bg-[var(--sunken,#eeece7)] overflow-hidden">
                <div
                  className="h-full rounded-full"
                  style={{ width: `${pct}%`, backgroundColor: entry.color }}
                />
              </div>
              <div className="w-[7.5rem] shrink-0 text-right">
                <p className="text-[13px] font-semibold tabular-nums text-[var(--ink,#1c1c1a)]">
                  {formatCurrency(entry.totalMRC)}
                </p>
                <p className="text-[11px] tabular-nums text-[var(--muted,#6b6a66)]">
                  {entry.percentage}% of total
                </p>
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default Report20ProviderDonutChart;
